import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "replace_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 4h11v11H12V4Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 12H4v11h11v-6h-5v-5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.5 9 11 1.803 3.5.5l1.568 2.392C3.204 4.176 2.026 6.492 2 9c-.013 1.321.214 2.696 1 4 .212-2.671 1.893-5.399 4.634-6.435L9.5 9Z"
    }, null, -1)
  ]))]))
}
export default { render: render }